type UnknownObject = Record<string, unknown>;
type BaseObject = Record<string, unknown>;

export default function isObject<
  T extends BaseObject = UnknownObject,
>(argument: unknown): argument is T {
  return argument !== null && typeof argument === 'object';
}
